import { ROUTE_ENTERPRISE_MEMBERS, ROUTE_ENTERPRISE_SETTINGS } from "../../app/constants";
import { EnterpriseMembers } from "./EnterpriseMembers";
import { EnterpriseSettings } from "./EnterpriseSettings";

export const ENTERPRISE_TABS = [
  { name: "Enterprise settings", path: ROUTE_ENTERPRISE_SETTINGS, tabComponent: () => <EnterpriseSettings /> },
  { name: "Enterprise members", path: ROUTE_ENTERPRISE_MEMBERS, tabComponent: () => <EnterpriseMembers /> },
];
